import type { CSSProperties, ReactNode } from 'react';

import { fromCamelCaseToWords } from '../../misc/functions';
import { getContrastColor } from '../../misc/color';
import { NO_DATA } from '../../misc/misc.constants';

interface ColorCellProps {
  column: string;
  bgColor: string;
  children: ReactNode;
}

export function ColorCell({ column, bgColor, children }: ColorCellProps) {
  const styles: CSSProperties = {};

  if (bgColor !== NO_DATA) {
    styles.color = getContrastColor(bgColor);
    styles.backgroundColor = bgColor;
  }

  return (
    <td
      data-title={fromCamelCaseToWords(column)}
      data-qa={column}
      style={styles}
    >
      {children}
    </td>
  );
}
